module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./~/@deskproapps/dpat/~/core-js/library/modules/_iterators.js
// module id = 50hw
// module chunks = 0